import { v4 as uuidv4 } from 'uuid';

export const generateShortKey = () => {
  const uuidComponents = uuidv4().split('-');

  return uuidComponents[0] + uuidComponents[1];
}